
/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/24
 * @updateTime 2021/8/24
 * @decription 申请保全 =》 被申请人
 */
// 标题组件
import Slogan from '@/components/common/slogan';
// 模块预览组件
import ccPreviewModule from '@/components/common/preview-module/index.vue';
import {
    typeGzdwlx,
    typeMz,
    typeRylx,
    typeSfzjlx,
    typeXb,
    typeZzlx} from "@/filters";

export default {
    name: 'Respondent',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        Slogan,
        ccPreviewModule
    },
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 数据列表
            data: [],
            // 转换后的数据
            transformData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 获取基本数据
        this.getData();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 请求数据
         * @param {Object} params 请求参数
         * */
        requestData(params) {
            return this.$axios.get('ssbq/api/bsqrs', params);
        },

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @returns {Object}
         * */
        getRowData(name, value) {
            return {
                name: name,
                value: value
            };
        },

        /**
         * 获取转化之后的数据
         * @returns {Array} 转化之后的信息项数组
         * */
        getTransformData(data) {
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('被申请人类型', data.cDsrlxName));
            // 被申请人类型为1 =》 自然人
            if (data.cDsrlx == 1) {
                _transformItemData.push(this.getRowData('姓名', data.cDsrxm));
                _transformItemData.push(this.getRowData('性别', data.cDsrxbName));
                _transformItemData.push(this.getRowData('民族', data.nMzName));
                _transformItemData.push(this.getRowData('年龄', data.nNl));
                _transformItemData.push(this.getRowData('出生日期', data.dtDsrbirthday));
                _transformItemData.push(this.getRowData('证件类型', data.cZjlxName));
                _transformItemData.push(this.getRowData('证件号码', data.cZjh));
            } else {
                // 被申请人类型为 2、3 =》 法人、非法人组织
                _transformItemData.push(this.getRowData('单位名称', data.cQymc));
                _transformItemData.push(this.getRowData('证照类型', data.nZzlxName));
                _transformItemData.push(this.getRowData('证照号码', data.cZzjgdm));
                _transformItemData.push(this.getRowData('单位性质', data.cDwxzName));
                _transformItemData.push(this.getRowData('法定代表人', data.cQyfr));
            }
            _transformItemData.push(this.getRowData('手机号码', data.cPhoneno));
            _transformItemData.push(this.getRowData('固定电话', data.cGddh));
            // 被申请人类型为1 =》 自然人
            if (data.cDsrlx == 1) {
                _transformItemData.push(this.getRowData('经常居住地', data.cTxdz));
            } else {
                // 被申请人类型为 2、3 =》 法人、非法人组织
                _transformItemData.push(this.getRowData('单位地址', data.cTxdz));
            }
            return _transformItemData;
        },

        /**
         * 获取数据
         * */
        getData() {
            // 请求申请人数据
            this.requestData({
                // 保全id
                bqid: sessionStorage.getItem('bqid')
            }).then(res => {
                const _data = res.data;
                const _transformData = [];
                _data.forEach((item) => {
                    // 申请人类型名称
                    item.cDsrlxName = typeRylx(item.cDsrlx);
                    // 申请人性别名称
                    item.cDsrxbName = typeXb(item.cDsrxb);
                    // 申请人民族名称
                    item.nMzName = typeMz(item.nMz);
                    // 证件类型名称
                    item.cZjlxName = typeSfzjlx(item.cZjlx);
                    // 证照类型名称
                    item.nZzlxName = typeZzlx(item.nZzlx);
                    // 单位性质名称
                    item.cDwxzName = typeGzdwlx(item.cDwxz);
                    // 转化之后的数据
                    _transformData.push(this.getTransformData(item));
                });
                // 数据赋值
                this.data = _data;
                // 转化之后的数据
                this.transformData = _transformData;
                // 加载完成
                this.$emit('loaded', this.data);
            });
        }
    }
};
